import {
    getOperationsService
    , getSitesService
    , getReasonNamesService
} from '@/services/health-tracker/absenteeism/V2/information-management/service'

const state = () => ({
    operations: []
    ,sites: []
    ,reasonNames: []
})

const mutations = {
    SET_OPERATIONS (state, operations) {
        state.operations = operations
    }
    , SET_SITES (state, sites) {
        state.sites = sites
    }
    , SET_REASON_NAMES (state, reasonNames) {
        state.reasonNames = reasonNames
    }
}

const actions = {
    async getOperationsStore ({ commit })
    {
        const { result } = await getOperationsService()
        commit('SET_OPERATIONS', result)
    }
    , async getSitesStore ({ commit })
    {
        const { result } = await getSitesService()
        commit('SET_SITES', result)
    }
    , async getReasonNamesStore ({ commit }, data = {})
    {
        const { result } = await getReasonNamesService(data)
        commit('SET_REASON_NAMES', result)
    }

}

const getters = {
    getOperations : (state) => { return state.operations }
    , getSites : (state) => { return state.sites }
    , getReasonNames : (state) => { return state.reasonNames }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
